export default __webpack_public_path__ + "static/media/ic_menu.0a6ce0ff.svg";